import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'olympus_sidebar_prefs';

const DEFAULT_PREFS = {
  favorites: [],
  hidden: [],
  order: [],  // leere order = alphabetisch
};

export function useSidebarPrefs() {
  const [prefs, setPrefs] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? { ...DEFAULT_PREFS, ...JSON.parse(saved) } : DEFAULT_PREFS;
    } catch {
      return DEFAULT_PREFS;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  }, [prefs]);

  const toggleFavorite = useCallback((path) => {
    setPrefs(p => {
      const favs = p.favorites.includes(path)
        ? p.favorites.filter(f => f !== path)
        : [...p.favorites, path];
      return { ...p, favorites: favs };
    });
  }, []);

  const toggleHidden = useCallback((path) => {
    setPrefs(p => {
      const hidden = p.hidden.includes(path)
        ? p.hidden.filter(h => h !== path)
        : [...p.hidden, path];
      return { ...p, hidden };
    });
  }, []);

  const unhideAt = useCallback((path, position) => {
    setPrefs(p => {
      const hidden = p.hidden.filter(h => h !== path);
      const order = [...p.order.filter(o => o !== path)];
      if (typeof position === 'number' && position >= 0) {
        order.splice(position, 0, path);
      }
      return { ...p, hidden, order };
    });
  }, []);

  const moveItem = useCallback((path, newIndex) => {
    setPrefs(p => {
      const order = [...p.order.filter(o => o !== path)];
      order.splice(newIndex, 0, path);
      return { ...p, order };
    });
  }, []);

  const setCustomOrder = useCallback((newOrder) => {
    setPrefs(p => ({ ...p, order: newOrder }));
  }, []);

  const resetAll = useCallback(() => {
    setPrefs(DEFAULT_PREFS);
  }, []);

  return {
    prefs,
    toggleFavorite,
    toggleHidden,
    unhideAt,
    moveItem,
    setCustomOrder,
    resetAll,
    isFavorite: (path) => prefs.favorites.includes(path),
    isHidden: (path) => prefs.hidden.includes(path),
  };
}
